import React from 'react';
import { Code } from 'lucide-react';

export default function HTMLCallToAction() {
  const scrollToGenerator = () => {
    document.getElementById('html-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-blue-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex justify-center mb-6">
          <Code className="w-12 h-12 text-blue-200" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-4">
          Ready to Generate Your HTML Code?
        </h2>
        <p className="text-xl text-blue-100 mb-8">
          Join thousands of developers who use our AI-powered HTML generator to create clean, semantic code.
        </p>
        <button 
          onClick={scrollToGenerator}
          className="bg-white text-blue-600 text-lg px-8 py-4 rounded-lg hover:bg-blue-50 transition-colors cursor-pointer shadow-lg hover:shadow-xl"
        >
          Start Generating HTML Now!
        </button>
        <p className="mt-6 text-sm text-blue-200">
          Perfect for developers of all skill levels
        </p>
      </div>
    </section>
  );
}